<template>
  <gas-page-shell :breadcrumb="['组织管理', '组织列表']">
    <div class="search-section">
      <div class="section-title"><span class="title-bar"></span>检索条件</div>
      <el-form :inline="true" :model="query" size="small" label-width="88px" class="search-form">
        <el-form-item label="组织名称">
          <el-input v-model="query.orgName" clearable placeholder="请输入组织名称" prefix-icon="el-icon-office-building" style="width:160px" />
        </el-form-item>
        <el-form-item label="组织编码">
          <el-input v-model="query.orgCode" clearable placeholder="请输入组织编码" style="width:160px" />
        </el-form-item>
        <el-form-item label="负责人">
          <el-input v-model="query.contactName" clearable placeholder="请输入负责人" prefix-icon="el-icon-user" style="width:140px" />
        </el-form-item>
        <el-form-item label="所属区域">
          <el-select v-model="query.regionName" clearable placeholder="全部区域" style="width:120px">
            <el-option v-for="r in regionOptions" :key="r" :label="r" :value="r" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="query.status" clearable placeholder="全部状态" style="width:120px">
            <el-option label="已启用" value="0" />
            <el-option label="已停用" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-refresh-left" @click="resetSearch">重置</el-button>
          <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="table-panel">
      <div class="table-toolbar">
        <div class="table-title-group">
          <span class="table-title">组织列表 <em>共 {{ total }} 条记录</em></span>
          <gas-table-toolbar
            :columns="tableColumnDefs"
            :visible-map.sync="tableColumnVisible"
            :selected-count="selectedIds.length"
            :show-batch-delete="tableCanBatchDelete"
            @batch-delete="batchRemove"
          />
        </div>
        <div class="toolbar-actions">
          <el-button type="primary" size="small" icon="el-icon-plus" @click="openCreate(emptyForm())">新增组织</el-button>
          <el-button size="small" class="btn-enable" :disabled="!selectedIds.length" @click="batchStatus('0')">批量启用</el-button>
          <el-button size="small" class="btn-disable" :disabled="!selectedIds.length" @click="batchStatus('1')">批量停用</el-button>
          <el-button size="small" class="btn-disable" :disabled="!selectedIds.length" @click="batchStatus('1')">批量停用</el-button>
          <el-button size="small" icon="el-icon-refresh" circle @click="loadData" />
        </div>
      </div>

      <el-table :data="list" v-loading="loading" border size="small" @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="44" align="center" />
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="{ $index }">{{ rowNo($index) }}</template>
        </el-table-column>
        <el-table-column label="组织名称" min-width="180">
          <template slot-scope="{ row }">
            <div class="org-cell" @click="openQuotaDrawer(row)">
              <span class="org-icon"><i class="el-icon-office-building"></i></span>
              <div>
                <div class="org-name">{{ row.orgName }}</div>
                <div class="org-parent">{{ parentLabel(row) }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="orgCode" label="组织编码" width="120" />
        <el-table-column prop="contactName" label="负责人" width="100" />
        <el-table-column prop="contactPhone" label="联系电话" width="120" />
        <el-table-column prop="address" label="办公地址" min-width="160" show-overflow-tooltip />
        <el-table-column label="所属区域" width="100" align="center">
          <template slot-scope="{ row }">
            <span class="region-link">{{ row.regionName || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="排序号" width="80" align="center">
          <template slot-scope="{ row }">{{ row.sortNo != null ? row.sortNo : 0 }}</template>
        </el-table-column>
        <el-table-column label="状态" width="96" align="center">
          <template slot-scope="{ row }">
            <span class="status-dot" :class="row.status === '0' ? 'on' : 'off'">
              {{ row.status === '0' ? '已启用' : '已停用' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="240" fixed="right" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" class="op-edit" @click="openEdit(row, emptyForm())">编辑</el-button>
            <el-button type="text" size="small" class="op-detail" @click="openDetail(row)">详情</el-button>
            <el-button type="text" size="small" class="op-quota" @click="openQuotaDrawer(row)">配额</el-button>
            <el-button type="text" size="small" class="op-move" @click="moveOrg(row)">移动</el-button>
            <el-button type="text" size="small" class="op-del" @click="removeRow(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pager"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        :current-page="query.pageNum"
        :page-size="query.pageSize"
        :page-sizes="[10, 20, 50]"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>

    <org-quota-drawer :visible.sync="quotaDrawerVisible" :org-id="quotaOrgId" />

    <el-dialog title="组织详情" :visible.sync="detailVisible" width="560px">
      <el-descriptions v-if="detailRow" :column="1" border size="small">
        <el-descriptions-item label="组织名称">{{ detailRow.orgName }}</el-descriptions-item>
        <el-descriptions-item label="组织编码">{{ detailRow.orgCode }}</el-descriptions-item>
        <el-descriptions-item label="上级组织">{{ parentLabel(detailRow) }}</el-descriptions-item>
        <el-descriptions-item label="负责人">{{ detailRow.contactName || '—' }}</el-descriptions-item>
        <el-descriptions-item label="联系电话">{{ detailRow.contactPhone || '—' }}</el-descriptions-item>
        <el-descriptions-item label="办公地址">{{ detailRow.address || '—' }}</el-descriptions-item>
        <el-descriptions-item label="所属区域">{{ detailRow.regionName || '—' }}</el-descriptions-item>
        <el-descriptions-item label="排序号">{{ detailRow.sortNo != null ? detailRow.sortNo : 0 }}</el-descriptions-item>
        <el-descriptions-item label="状态">{{ detailRow.status === '0' ? '已启用' : '已停用' }}</el-descriptions-item>
        <el-descriptions-item label="备注">{{ detailRow.remark || '—' }}</el-descriptions-item>
      </el-descriptions>
    </el-dialog>

    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="640px">
      <el-form :model="form" label-width="100px" size="small">
        <el-form-item label="组织名称" required><el-input v-model="form.orgName" /></el-form-item>
        <el-form-item label="组织编码" required><el-input v-model="form.orgCode" :disabled="!!form.orgId" /></el-form-item>
        <el-form-item label="上级组织">
          <el-select v-model="form.parentId" clearable placeholder="顶级组织" style="width:100%">
            <el-option label="顶级组织" :value="0" />
            <el-option v-for="o in parentOptions" :key="o.orgId" :label="o.orgName" :value="o.orgId" />
          </el-select>
        </el-form-item>
        <el-form-item label="负责人"><el-input v-model="form.contactName" /></el-form-item>
        <el-form-item label="联系电话"><el-input v-model="form.contactPhone" /></el-form-item>
        <el-form-item label="办公地址"><el-input v-model="form.address" type="textarea" :rows="2" /></el-form-item>
        <el-form-item label="所属区域">
          <el-select v-model="form.regionName" allow-create filterable style="width:100%">
            <el-option v-for="r in regionOptions" :key="r" :label="r" :value="r" />
          </el-select>
        </el-form-item>
        <el-form-item label="排序号"><el-input v-model.number="form.sortNo" /></el-form-item>
        <el-form-item label="状态">
          <el-select v-model="form.status" style="width:100%">
            <el-option label="已启用" value="0" /><el-option label="已停用" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注"><el-input v-model="form.remark" type="textarea" :rows="2" /></el-form-item>
      </el-form>
      <span slot="footer"><el-button @click="dialogVisible = false">取消</el-button><el-button type="primary" @click="submitForm">保存</el-button></span>
    </el-dialog>
  </gas-page-shell>
</template>

<script>
import GasPageShell from '@/components/GasPageShell.vue'
import OrgQuotaDrawer from '@/components/OrgQuotaDrawer.vue'
import gasCrudPage from '@/mixins/gasCrudPage'
import { gasApi } from '@/api/gas'

const emptyForm = () => ({ status: '0', parentId: 0, sortNo: 0 })

export default {
  components: { GasPageShell, OrgQuotaDrawer },
  mixins: [gasCrudPage],
  data() {
    return {
      idField: 'orgId',
      listApi: gasApi.org.list,
      saveApi: gasApi.org.save,
      removeApi: gasApi.org.remove,
      batchRemoveApi: gasApi.org.batchRemove,
      parentOptions: [],
      regionOptions: ['华东区域', '华南区域', '华北区域', '西南区域', '西北区域'],
      quotaDrawerVisible: false,
      quotaOrgId: null,
      detailVisible: false,
      detailRow: null,
      query: {
        pageNum: 1,
        pageSize: 10,
        keyword: '',
        status: '',
        orgName: '',
        orgCode: '',
        contactName: '',
        regionName: ''
      }
    }
  },
  created() {
    this.loadParentOptions()
  },
  methods: {
    emptyForm,
    buildQuery() {
      const p = { ...this.query }
      Object.keys(p).forEach(k => { if (p[k] === '') delete p[k] })
      return p
    },
    async loadData() {
      if (!this.listApi) return
      this.loading = true
      try {
        const res = await this.listApi(this.buildQuery())
        const data = res.data || {}
        this.list = data.records || []
        this.total = Number(data.total || 0)
      } finally {
        this.loading = false
      }
    },
    async loadParentOptions() {
      const res = await gasApi.org.list({ pageNum: 1, pageSize: 500 })
      this.parentOptions = (res.data || {}).records || []
    },
    resetSearch() {
      this.query = {
        pageNum: 1,
        pageSize: this.query.pageSize,
        keyword: '',
        status: '',
        orgName: '',
        orgCode: '',
        contactName: '',
        regionName: ''
      }
      this.loadData()
    },
    search() {
      this.query.pageNum = 1
      this.loadData()
    },
    rowNo(i) {
      return (this.query.pageNum - 1) * this.query.pageSize + i + 1
    },
    parentLabel(row) {
      if (!row.parentId || row.parentId === 0) return '顶级组织'
      return row.parentOrgName ? `上级：${row.parentOrgName}` : '上级组织'
    },
    openQuotaDrawer(row) {
      this.quotaOrgId = row.orgId
      this.quotaDrawerVisible = true
    },
    openDetail(row) {
      this.detailRow = { ...row }
      this.detailVisible = true
    },
    moveOrg(row) {
      this.$message.info(`组织「${row.orgName}」移动功能待对接`)
    },
    async batchStatus(status) {
      if (!this.selectedIds.length) return this.$message.warning('请先选择组织')
      await gasApi.org.batchStatus({ ids: this.selectedIds, status })
      this.$message.success('操作成功')
      this.loadData()
    },
    afterBatchRemove() {
      this.loadParentOptions()
    },
    openEdit(row, defaults) {
      gasCrudPage.methods.openEdit.call(this, row, defaults)
      if (this.form.parentId == null) this.form.parentId = 0
    },
    openCreate(defaults) {
      gasCrudPage.methods.openCreate.call(this, defaults)
    },
    async submitForm() {
      if (!this.form.orgName || !this.form.orgCode) return this.$message.warning('请填写组织名称和编码')
      if (this.form.parentId == null) this.form.parentId = 0
      await gasCrudPage.methods.submitForm.call(this)
      this.loadParentOptions()
    },
    async removeRow(row) {
      await gasCrudPage.methods.removeRow.call(this, row)
      this.loadParentOptions()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/report-flow.scss';

.search-section {
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  padding: 16px 16px 4px;
  margin-bottom: 16px;
}
.section-title {
  display: flex;
  align-items: center;
  font-weight: 600;
  margin-bottom: 12px;
}
.title-bar {
  width: 3px;
  height: 14px;
  background: #1677ff;
  margin-right: 8px;
}
.search-form >>> .el-form-item {
  margin-bottom: 12px;
}
.table-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-bottom: 12px;
}
.toolbar-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}
.btn-enable { color: #00b42a; border-color: #00b42a; }
.btn-disable { color: #86909c; border-color: #c9cdd4; }
.btn-del { color: #f53f3f; border-color: #f53f3f; }

.org-cell {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  cursor: pointer;
}
.org-icon {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: #e8f3ff;
  color: #1677ff;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.org-name {
  color: #1677ff;
  font-weight: 500;
}
.org-name:hover {
  text-decoration: underline;
}
.org-parent {
  font-size: 12px;
  color: #86909c;
  margin-top: 2px;
}
.region-link {
  color: #1677ff;
}
.status-dot.on {
  color: #00b42a;
}
.status-dot.on::before {
  content: '● ';
}
.status-dot.off {
  color: #86909c;
}
.status-dot.off::before {
  content: '● ';
}
.op-edit { color: #1677ff; }
.op-detail { color: #722ed1; }
.op-quota { color: #ff7d00; }
.op-move { color: #86909c; }
.op-del { color: #f53f3f; }
</style>
